export default __webpack_public_path__ + "static/app_screenshot_3-0f706f6d90730723b5cbe01e66d91379.webp";